import { dimensionMock, wordSuggestionsMock } from "./consts";
import { WordSuggestionsResponse } from "./types";

export const fetchWordSuggestions = async (
  word: string,
  topN: number,
  displayAll: boolean,
  functionKey: string,
  dimension?: string
): Promise<WordSuggestionsResponse> => {
  if (process.env.REACT_APP_USE_MOCKED_API === "true") {
    await new Promise((resolve) => setTimeout(resolve, 500));
    return { ...wordSuggestionsMock };
  }
  const apiRequest = process.env.REACT_APP_WORD_SUGGESTIONS_URL + functionKey;
  const requestBody: Record<string, unknown> = {
    word: word,
    top_n: topN,
    display_all: displayAll,
  };
  if (dimension) {
    requestBody.dimension = dimension;
  }
  const response = await fetch(apiRequest, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(requestBody),
  });
  if (!response.ok) {
    throw new Error(await response.text());
  }
  return response.json() as Promise<WordSuggestionsResponse>;
};

export const sendDimensionRequest = async (
  functionKey: string
): Promise<Response> => {
  if (process.env.REACT_APP_USE_MOCKED_API === "true") {
    await new Promise((resolve) => setTimeout(resolve, 1500));

    return {
      ok: true,
      text: async () => JSON.stringify(dimensionMock),
    } as Response;
  }

  const apiRequest = `${process.env.REACT_APP_DIMENSION_URL}${functionKey}`;
  const response = await fetch(apiRequest, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response;
};
